import { DialogStateManager } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { useCallback } from 'react';
import type { TaskCreateDialogProps } from '../components/task-bulk-create-dialog.tsx';
import { TaskBulkCreateDialog } from '../components/task-bulk-create-dialog.tsx';

export function useShowCreateTaskDialog(): (props: TaskCreateDialogProps) => void {
    return useCallback((props: TaskCreateDialogProps) => {
        void DialogStateManager.show(TaskBulkCreateDialog, props);
    }, []);
}
